




















































import { createComponent, computed } from "@vue/composition-api";
// eslint-disable-next-line
import { RiskLevel } from "@dcc/types/riskLevel";
import { getRiskText } from "@dcc/constants/riskLevels";
import BingeDrinkerWarning from "@dcc/components/BingeDrinkerWarning.vue";
import { DrinkFrequency } from "../types/drinkFrequency";
import { useDictionary } from "@dcc/views/compositions/useDictionary";
import { DictionaryField } from "@dcc/lookup/dictionary/fields";

interface DrinkRiskLevelProps {
  riskLevel: RiskLevel;
  isBingeDrinker: boolean;
  isLowRiskBingeDrinker: boolean;
  drinkFrequency: DrinkFrequency;
}

export default createComponent({
  components: {
    BingeDrinkerWarning
  },
  props: {
    riskLevel: {
      type: Number as () => RiskLevel,
      required: true
    },
    isBingeDrinker: {
      type: Boolean,
      required: true
    },
    isLowRiskBingeDrinker: {
      type: Boolean,
      required: true
    },
    drinkFrequency: {
      type: Number as () => DrinkFrequency,
      required: true
    }
  },
  setup(props: DrinkRiskLevelProps) {
    const dictionary = useDictionary();
    const {
      weeklyRiskDescription,
      monthlyRiskDescription,
      riskTitle
    } = getRiskText(props.isBingeDrinker);
    const descriptionLookup = computed(() =>
      props.drinkFrequency === DrinkFrequency.Weekly
        ? weeklyRiskDescription
        : monthlyRiskDescription
    );

    const riskLabel = props.isLowRiskBingeDrinker
      ? dictionary.dictionary[DictionaryField.DCC_RESULTS_LOWRISKBINGEWARNING]
      : riskTitle[props.riskLevel];

    return {
      riskTitle,
      descriptionLookup,
      RiskLevel,
      riskLabel,
      ...dictionary
    };
  }
});
